const r0 = new RegExp(/^\/media\/stores\/foodservice-requests\/v0\//);
const r1 = new RegExp("https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a011/media/apps/arcimedes/v0/", 'g');
const r5 = new RegExp("http://foodservices.davidscookies.com/media/apps/arcimedes/v0/", 'g');

export default function (text) {
	return text
		.replace(r0, arc.path.cartMedia)
		.replace(r1, arc.path.arcMedia)
		.replace(r5, arc.path.arcMedia);
}